import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Link,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const Navbar = (): React.ReactElement => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <List>
        <ListItem
          button
          component={RouterLink}
          to="/"
          onClick={() => setMobileOpen(false)}
        >
          <ListItemText primary="Home" />
        </ListItem>
        <ListItem
          button
          component={RouterLink}
          to="/privacy-policy"
          onClick={() => setMobileOpen(false)}
        >
          <ListItemText primary="Privacy Policy" />
        </ListItem>
        <ListItem
          button
          component={RouterLink}
          to="/terms-of-use"
          onClick={() => setMobileOpen(false)}
        >
          <ListItemText primary="Terms of Use" />
        </ListItem>
        {/* <ListItem button component={RouterLink} to="/faq" onClick={() => setMobileOpen(false)}>
          <ListItemText primary="FAQ" />
        </ListItem> */}
      </List>
    </div>
  );

  return (
    <AppBar
      position="static"
      sx={{
        px: {
          xs: theme.spacing(5),
          md: theme.spacing(7),
          lg: theme.spacing(12),
        },
        backgroundColor: "transparent",
        color: "black",
        boxShadow: "none",
      }}
    >
      <Toolbar>
        <Typography
          variant="h6"
          fontWeight={"bold"}
          component="div"
          sx={{ flexGrow: 1, color: "black" }}
        >
          Rotten Egg
        </Typography>
        {isMobile ? (
          <>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "block" } }}
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                display: { xs: "block", sm: "block" },
                "& .MuiDrawer-paper": { boxSizing: "border-box", width: 240 },
              }}
            >
              {drawer}
            </Drawer>
          </>
        ) : (
          <>
            <Link
              component={RouterLink}
              to="/"
              color="inherit"
              underline="none"
            >
              <Button color="inherit">Home</Button>
            </Link>
            <Link
              component={RouterLink}
              to="/privacy-policy"
              color="inherit"
              underline="none"
            >
              <Button color="inherit">Privacy Policy</Button>
            </Link>
            <Link
              component={RouterLink}
              to="/terms-of-use"
              color="inherit"
              underline="none"
            >
              <Button color="inherit">Terms of Use</Button>
            </Link>
            {/* <Link component={RouterLink} to="/faq" color="inherit" underline="none">
              <Button color="inherit">FAQ</Button>
            </Link> */}
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
